<template>
  <div class="datepicker">
    <v-menu
        ref="menu"
        v-model="menu"
        :close-on-content-click="false"
        :nudge-right="40"
        lazy
        transition="scale-transition"
        offset-y
        full-width
        max-width="290px"
        min-width="290px"
    >
      <template v-slot:activator="{ on }">
        <v-text-field
            :value="formattedDate"
            :label="getTranslatedText(title)"
            persistent-hint
            prepend-icon="event"
            v-on="on"
            outlined
            dense
            placeholder="dd-mm-yyyy"
            @input="onInputDate"
        >
        </v-text-field>
        <div @click="menu = true" class="datepicker__calendar">
          <img src="~ThemePath/images/results/calendar.png/"/>
        </div>
      </template>
      <v-date-picker
          v-model="date"
          no-title
          @input="menu = false"
          @change="onChangeDate"
          :show-current="this.srvTime() ? this.handleFormatDate(this.$helpers.formatDate(this.srvTime())) : true"
      ></v-date-picker>
    </v-menu>
  </div>
</template>

<script>
import languageMixins from "@/mixins/language/language-mixins";
import getSrvTime from "@/mixins/getSrvTime/getSrvTime-mixins";
import EventBus from '@/utils/EventBus';

export default {
  mixins: [languageMixins, getSrvTime],
  props: {
    title: {
      type: String,
      default: "",
    },
  },
  data: () => ({
    menu: false,
    date: null
  }),
  created() {
    EventBus.$on("ChangeData", this.changeDate);
  },
  beforeDestroy() {
    EventBus.$off("ChangeData");
  },
  computed: {
    formattedDate() {
      return this.date ? this.$helpers.formatDate(this.date) : "";
    },
  },
  methods: {
    onInputDate(date) {
      this.$emit("input", date);
    },
    onChangeDate() {
      this.$emit("input", this.date);
    },
    changeDate(data) {
      this.date = data;
    },
    handleFormatDate(date) {
      const dateParts = date.split('-');
      return `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`;
    }
  },
};
</script>

<style lang="scss">
@import "~ThemePath/scss/common/_datepicker.scss";
</style>
